function promptToggle(element, classes) {
  classes.forEach(className => element.classList.toggle(className));
}

function getStatusPrompt() {
  return localStorage.getItem('statusPrompt') || null;
}

function setStatusPrompt(status) {
  localStorage.setItem('statusPrompt', status);
}

function registerServiceWorker() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register('/pwa-sw.js');
  }
}

function showPromptModal(deferredPrompt, promptModal) {
  promptToggle(promptModal, ['hide', 'show']);
  deferredPrompt.prompt();
  deferredPrompt.userChoice
    .then((choiceResult) => {
      setStatusPrompt(choiceResult.outcome === 'accepted' ? 'accepted' : 'dismissed');
      deferredPrompt = null;
    });
}

document.addEventListener('DOMContentLoaded', () => {
  registerServiceWorker();

  const promptModal = document.querySelector('#promptModal');
  const buttonAdd = document.querySelector('#buttonAdd');
  const buttonCancel = document.querySelector('#buttonCancel');

  let deferredPrompt;
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    deferredPrompt = e;
    if (!getStatusPrompt()) {
      promptToggle(promptModal, ['hide', 'show']);
    }
  });

  buttonCancel.addEventListener('click', () => {
    promptToggle(promptModal, ['hide', 'show']);
    setStatusPrompt('dismissed');
  });

  buttonAdd.addEventListener('click', () => {
    showPromptModal(deferredPrompt, promptModal);
  });
});
